import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { Core } from "@faire/design-tokens";
import Fuse from "fuse.js";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { SearchField, SelectedValue, SelectField, SelectFieldChevron, SelectFieldWrapper, SelectOptions } from "./styles";
export var SearchableSelect = function SearchableSelect(props) {
  var fuse = useRef(newFuse(props.options, props.searchKeys));
  useEffect(function () {
    var _props$options;
    if ((_props$options = props.options) !== null && _props$options !== void 0 && _props$options.length) {
      fuse.current = newFuse(props.options, props.searchKeys);
    }
  }, [props.options, props.searchKeys]);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    filteredOptions = _useState4[0],
    setFilteredOptions = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showOptions = _useState6[0],
    setShowOptions = _useState6[1];
  var toggleOptions = function toggleOptions() {
    return setShowOptions(!showOptions);
  };
  var closeOptions = function closeOptions() {
    return setShowOptions(false);
  };
  var onSelect = function onSelect(selected) {
    var _props$onSelect;
    (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 ? void 0 : _props$onSelect.call(props, selected);
    setSelected(selected);
    setShowOptions(false);
  };
  var handleSearch = function handleSearch(event) {
    var _fuse$current;
    var searchTerm = event.currentTarget.value;
    if (!searchTerm) {
      setFilteredOptions(undefined);
      return;
    }
    var filteredOptions = (_fuse$current = fuse.current) === null || _fuse$current === void 0 ? void 0 : _fuse$current.search(searchTerm).map(function (result) {
      return result.item;
    });
    setFilteredOptions(filteredOptions);
  };
  var disabled = !props.options.length || !!props.disabled;
  return /*#__PURE__*/React.createElement(SelectFieldWrapper, {
    onClickOutside: closeOptions
  }, /*#__PURE__*/React.createElement(SelectField, {
    disabled: disabled,
    onClick: !disabled ? toggleOptions : undefined
  }, selected ? ( /*#__PURE__*/React.createElement(SelectedValue, null, props.children)) : ( /*#__PURE__*/React.createElement(SearchField, {
    disabled: disabled,
    placeholder: props.placeholder,
    onChange: handleSearch
  })), /*#__PURE__*/React.createElement(SelectFieldChevron, {
    color: Core.icon.subdued,
    direction: "down"
  })), showOptions ? ( /*#__PURE__*/React.createElement(SelectOptions, null, (filteredOptions || props.options).map(function (option) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: option.value
    }, props.renderOption({
      option: option,
      onSelect: onSelect
    }));
  }))) : null);
};
var newFuse = function newFuse(options, searchKeys) {
  return new Fuse(options, {
    minMatchCharLength: 2,
    keys: searchKeys
  });
};